var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 10.0602C7.7132 10.0602 7.42649 9.95072 7.20786 9.7322L0.328226 2.85249C-0.109409 2.41486 -0.109409 1.70531 0.328226 1.26785C0.765684 0.830394 1.47509 0.830394 1.91276 1.26785L7.99996 7.3554L14.0872 1.26806C14.5248 0.830606 15.2342 0.830606 15.6716 1.26806C16.1094 1.70552 16.1094 2.41507 15.6716 2.85271L8.79205 9.73242C8.57332 9.95097 8.2866 10.0602 7.99996 10.0602Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackDownArrow);
export default __webpack_public_path__ + "static/media/black_down_arrow.0082dfbce7ecdff728756f434d484a70.svg";
export { ForwardRef as ReactComponent };